module.exports = __webpack_public_path__ + "img/gloves.8bb5e6e6.svg";